import { useState, useRef } from 'react';

/** Dropping import files onto the sidebar. */
export function useSidebarFileDrop({
  onImportFileDrop,
}) {
  // ── Sidebar-wide OS file drop ("Import into Apiboo") ───────────────────────
  const [fileDragActive, setFileDragActive] = useState(false);
  const fileDragCounterRef = useRef(0);

  // Only NATIVE file drags count: reordering rows in this sidebar is
  // pointer-event DnD (dnd-kit) and never carries a dataTransfer, and a
  // text/request drag must not summon the overlay either.
  const isFileDrag = (e) => {
    const types = e.dataTransfer?.types;
    return !!types && Array.prototype.includes.call(types, 'Files');
  };

  const handleFileDragEnter = (e) => {
    if (!isFileDrag(e)) return;
    e.preventDefault();
    fileDragCounterRef.current += 1;
    setFileDragActive(true);
  };

  const handleFileDragOver = (e) => {
    if (!isFileDrag(e)) return;
    e.preventDefault();
    if (e.dataTransfer) e.dataTransfer.dropEffect = 'copy';
  };

  const handleFileDragLeave = (e) => {
    if (!isFileDrag(e)) return;
    e.preventDefault();
    // Counter, not a boolean: entering a child fires leave on the parent
    // and the overlay would flicker on every row the cursor crosses.
    fileDragCounterRef.current -= 1;
    if (fileDragCounterRef.current <= 0) {
      fileDragCounterRef.current = 0;
      setFileDragActive(false);
    }
  };

  const handleFileDrop = (e) => {
    if (!isFileDrag(e)) return;
    e.preventDefault();
    fileDragCounterRef.current = 0;
    setFileDragActive(false);
    const file = e.dataTransfer?.files?.[0];
    if (!file) return;
    // Direct import, no modal (owner call, 24.08.2026): the App-level
    // handler owns acceptance, parsing, the import itself and the toast —
    // the sidebar only hands the file over.
    onImportFileDrop?.(file);
  };

  return {
    fileDragActive,
    handleFileDragEnter,
    handleFileDragOver,
    handleFileDragLeave,
    handleFileDrop,
  };
}
